<template>
    <div>
        <el-dialog title="(添加/修改) 特惠商品" :visible.sync="visible" width="20%" center>
            <el-form size="mini" ref="formName" :model="goodsModel" :rules="rules" label-width="110px"
                     style="margin:0 auto;">

                <el-form-item label="抢购时段:" prop="seckillTimeId">
                    <el-select v-model="goodsModel.seckillTimeId" placeholder="时段">
                        <el-option
                                v-for="item in times"
                                :key="item.id"
                                :label="item.startTime+' - '+item.endTime"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="商品:" prop="goodsId">
                    <el-button v-if="JSON.stringify(goods)==='{}'" type="info" @click="openGoods" icon="el-icon-plus"
                               plain/>
                    <el-checkbox v-else checked disabled :label="goods.name" border/>
                </el-form-item>

                <el-form-item label="商品规格:" prop="goodsPriceId">
                    <el-select v-model="goodsModel.goodsPriceId" placeholder="商品规格">
                        <el-option
                                v-for="item in goodsPrice"
                                :key="item.id"
                                :label="item.name+' (原价：'+item.price+')'"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="抢购单价:" prop="seckillPrice">
                    <el-input-number v-model="goodsModel.seckillPrice" :precision="2" :min="0.00"
                                     label="抢购单价"/>
                </el-form-item>

                <el-form-item label="抢购数量:" prop="goodsAmount">
                    <el-input-number :precision="0" v-model="goodsModel.goodsAmount"
                                     :min="0.00"
                                     label="抢购数量"/>
                </el-form-item>

                <el-form-item label="单人限购次数:">
                    <el-col :span="6">
                        <el-tooltip :content="'是否单人限购次数'" placement="top">
                            <el-switch
                                    v-model="buyLimitFlag"
                                    active-color="#13ce66"
                                    inactive-color="#ff4949"
                            />
                        </el-tooltip>
                    </el-col>
                    <el-col :span="18">
                        <el-input-number v-show="buyLimitFlag" :precision="0" v-model="goodsModel.buyLimit"
                                         label="限购数量"/>
                    </el-col>

                </el-form-item>

                <el-form-item>
                    <el-button type="primary" @click="saveDiscountGoods('formName')">保存</el-button>
                    <el-button type="danger" v-show="goodsId" @click="deleteGoods">删除</el-button>
                    <el-button @click="closeDialog">取消</el-button>
                </el-form-item>

            </el-form>

        </el-dialog>
        <goods-select v-bind:success="otherSuccess" :multiple="false" ref="goodsSelect"></goods-select>
    </div>
</template>
<script>
    import goodsSelect from '@/views/goods/goods-select.vue';

    export default {
        data() {
            return {
                buyLimitFlag: false,
                goodsModel: {},
                visible: false,
                rules: {
                    seckillTimeId: [{required: true, message: "请选择抢购时间段", trigger: "blur"}],
                    goodsId: [{required: true, message: "请选择商品", trigger: "blur"}],
                    goodsPriceId: [{required: true, message: "请选择商品规格", trigger: "blur"}],
                    seckillPrice: [{required: true, message: "请输入抢购单价", trigger: "blur"}],
                    goodsAmount: [{required: true, message: "请输入特惠商品数量", trigger: "blur"}],
                },
                goods: {},
                goodsPrice: []
            }
        },
        components: {
            goodsSelect,
        },
        props: {
            success: {
                type: Function
            },
            times: {
                type: Array,
            },
            timeId: {
                type: String,
            },
            goodsId: {
                type: String
            }
        },
        watch: {
            timeId: {
                handler(newVal, oldVal) {
                    this.$set(this.goodsModel, 'seckillTimeId', newVal);
                },
            },
            goodsId: {
                handler(newVal, oldVal) {
                    this.goodsId = newVal;
                    this.findDiscountGoodsDetail();
                },
            }
        },
        created() {
            const _this = this;
            if (_this.timeId) {
                _this.$set(_this.goodsModel, 'seckillTimeId', _this.timeId);
            }
            if (_this.goodsId) {
                _this.findDiscountGoodsDetail();
            }
        },
        methods: {
            findDiscountGoodsDetail() {
                const _this = this;
                _this.$common.ajaxRequest({
                    url: 'seckillGoods/detailSeckillGoods',
                    data: {
                        seckillGoodsId: _this.goodsId
                    },
                    success: res => {
                        _this.goodsModel = res.item;
                        _this.findGoodsDetail(_this.goodsModel.goodsId)
                        _this.findGoodsPrice();
                        if (_this.goodsModel.buyLimit && this.goodsModel.buyLimit > 0) {
                            _this.buyLimitFlag = true;
                        } else {
                            _this.buyLimitFlag = false;
                        }
                    }
                });
            },
            findGoodsDetail(_goodsId) {
                const _this = this;
                _this.$common.ajaxRequest({
                    url: 'goods/detailGoods',
                    data: {
                        goodsId: _goodsId
                    },
                    success: res => {
                        _this.goods = res.item;
                    }
                });
            },
            saveDiscountGoods(formName) {
                const _this = this;
                console.log(_this.goodsModel);
                _this.$refs[formName].validate((valid) => {
                    if (valid) {
                        if (!_this.buyLimitFlag) {
                            _this.$set(_this.goodsModel, 'buyLimit', -1);
                        }
                        _this.$common.ajaxRequest({
                            url: 'seckillGoods/saveSeckillGoods',
                            data: _this.goodsModel,
                            success: res => {
                                _this.$message({
                                    message: '保存成功',
                                    type: 'success',
                                    duration: 1000,
                                    onClose: function () {
                                        _this.closeDialog();
                                        _this.success()
                                    }
                                });
                            }
                        });
                    } else {
                        return false;
                    }
                });

            },
            otherSuccess(goods) {
                this.goods = goods;
                this.goodsModel.goodsId = this.goods.id;
                this.$refs.goodsSelect.closeDialog();
                if (this.goodsModel.goodsId) {
                    this.findGoodsPrice();
                }
            },
            openGoods() {
                this.$refs.goodsSelect.openDialog()
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
            },
            openDialog() {
                this.visible = true;
            },
            closeDialog() {
                this.visible = false;
            },
            findGoodsPrice() {
                const _this = this;
                _this.goodsPrice = [];
                _this.$common.my_ajax({
                    url: 'goodsPrice/pageGoodsPrice',
                    data: {
                        goodsId: _this.goodsModel.goodsId
                    },
                    success: function (response) {
                        _this.goodsPrice = response.items;
                    }
                });

            },
            deleteGoods() {
                const _this = this;
                _this.$common.ajaxRequest({
                    url: '/seckillGoods/deleteSeckillGoods',
                    data: {
                        seckillGoodsId: _this.goodsId,
                    },
                    success(response) {
                        _this.closeDialog();
                        _this.success()
                    }
                })
            },
            clearGoods() {
                this.goodsModel = {};
                this.goods = {};
                this.goodsPrice = [];
            }
        }
    }
</script>
<style scoped>
</style>